// Show collection-membership badges (Buy 2 Get 1, Gift with purchase) based on product
// handle, not collection URL - needed because Wizzy renders its own product card markup
// (snippets/wizzy.search.results.product.liquid) for search/PLP results, bypassing the
// theme's own product-card.liquid where collection membership is already checked in Liquid.
// window.buy2get1Handles / window.gwpHandles are Sets of product handles injected by
// theme.liquid.
var COLLECTION_BADGES = [
  { handles: "buy2get1Handles", attr: "buy2get1-handle", prop: "buy2get1Handle" },
  { handles: "gwpHandles", attr: "gwp-handle", prop: "gwpHandle" }
];

function showCollectionBadges() {
  COLLECTION_BADGES.forEach(function (badgeType) {
    var handles = window[badgeType.handles];

    if (!handles || handles.size === 0) {
      return;
    }

    document.querySelectorAll("[data-" + badgeType.attr + "]").forEach(function (badge) {
      if (handles.has(badge.dataset[badgeType.prop])) {
        badge.style.display = "";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", showCollectionBadges);

// Handle Wizzy search results that load dynamically after page load.
// One run per frame; the rAF callback still runs before the next paint.
if (typeof MutationObserver !== "undefined") {
  var badgeFramePending = false;
  var observer = new MutationObserver(function () {
    if (badgeFramePending) {
      return;
    }

    badgeFramePending = true;
    requestAnimationFrame(function () {
      badgeFramePending = false;
      showCollectionBadges();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function addHandlesToSet(targetSetName, handles) {
  if (!window[targetSetName]) {
    window[targetSetName] = new Set();
  }

  handles.forEach(function (handle) {
    window[targetSetName].add(handle);
  });

  showCollectionBadges();
}

// Liquid's collection.products is capped at 50 products, so the Sets seeded by
// theme.liquid are incomplete when the collection has more products.
// Fallback path: fetch ALL handles from Shopify's AJAX API (250 per page) and extend the Set.
function fetchHandlesFromProductsJson(collectionHandle, targetSetName) {
  var page = 1;

  function fetchPage() {
    fetch("/collections/" + collectionHandle + "/products.json?limit=250&page=" + page)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          return;
        }

        addHandlesToSet(targetSetName, data.products.map(function (product) {
          return product.handle;
        }));

        if (data.products.length === 250) {
          page++;
          fetchPage();
        }
      })
      .catch(function () { /* silently ignore network errors */ });
  }

  fetchPage();
}

// Preferred path: handles-only feed from sections/collection-badge-handles.liquid, 250 per
// page. Any non-200 or unreadable response falls back to products.json for this collection.
function fetchAllHandlesForCollection(collectionHandle, targetSetName) {
  var page = 1;

  function fetchPage() {
    fetch("/collections/" + collectionHandle + "?section_id=collection-badge-handles&page=" + page)
      .then(function (res) {
        if (!res.ok) {
          throw new Error("badge feed " + res.status);
        }

        return res.text();
      })
      .then(function (html) {
        var node = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("script[data-badge-handles]");
        var data = JSON.parse(node.textContent);

        if (!Array.isArray(data.handles)) {
          throw new Error("badge feed shape");
        }

        if (data.handles.length === 0) {
          return;
        }

        addHandlesToSet(targetSetName, data.handles);

        if (page < data.pages) {
          page++;
          fetchPage();
        }
      })
      .catch(function () {
        fetchHandlesFromProductsJson(collectionHandle, targetSetName);
      });
  }

  fetchPage();
}

fetchAllHandlesForCollection("buy-2-get-1-free", "buy2get1Handles");

if (window.gwpCollectionHandle) {
  fetchAllHandlesForCollection(window.gwpCollectionHandle, "gwpHandles");
}
